import React, { useMemo } from "react";

import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons/faEllipsisH";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import { MenuProps } from "antd/es/menu";
import { useIntl } from "react-intl";

import { Territory } from "@mapmycustomers/shared/types/entity";

import styles from "./TerritoryMenu.module.scss";

interface Props {
  onDelete?: () => void;
  onEdit?: () => void;
  onExport?: () => void;
  onRename?: () => void;
  territory?: Territory;
}

const TerritoryMenu: React.FC<Props> = ({ onDelete, onEdit, onExport, onRename, territory }) => {
  const intl = useIntl();

  const menu: MenuProps = useMemo(
    () => ({
      items: [
        {
          disabled: !onExport,
          key: "export",
          label: intl.formatMessage({
            id: "map.territoryMode.sidebar.title.menu.download",
            defaultMessage: "Download territory records",
            description: "Quick Export menu item in Territory View mode",
          }),
          onClick: onExport,
        },
        {
          disabled: !territory?.accessStatus.update,
          key: "edit",
          label: intl.formatMessage({
            id: "map.territoryMode.sidebar.title.menu.editBounds",
            defaultMessage: "Edit Territory Bounds",
            description: "Edit Bounds menu item in Territory View mode",
          }),
          onClick: onEdit,
        },
        {
          disabled: !territory?.accessStatus.update,
          key: "rename",
          label: intl.formatMessage({
            id: "map.territoryMode.sidebar.title.menu.editName",
            defaultMessage: "Edit Name",
            description: "Rename menu item in Territory View mode",
          }),
          onClick: onRename,
        },
        {
          disabled: !territory?.accessStatus.delete,
          key: "delete",
          label: intl.formatMessage({
            id: "map.territoryMode.sidebar.title.menu.delete",
            defaultMessage: "Delete Territory",
            description: "Delete menu item in Territory View mode",
          }),
          onClick: onDelete,
        },
      ],
    }),
    [intl, onDelete, onEdit, onExport, onRename, territory?.accessStatus]
  );

  if (!territory?.accessStatus.update && !territory?.accessStatus.delete) {
    return null;
  }

  return (
    <Dropdown menu={menu} trigger={["click"]}>
      <FontAwesomeIcon className={styles.menuIcon} icon={faEllipsisH} />
    </Dropdown>
  );
};

export default TerritoryMenu;
